<template>
  <BaseCardV2
    titre=""
    class="pa-2"
  >
    <div
      v-if="errorMessage"
      class="mb-4"
    >
      <BaseMessage
        type="error"
        color="error"
        :message="errorMessage"
      />
    </div>
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading" />
      <div v-else>
        <v-row
          class="mx-5"
          no-gutters
        >
          <v-col
            cols="12"
            md="1"
            class="align-self-center"
          >
            <img
              src="@/assets/no-contrats.svg"
              alt="no-contrats"
              :class="$vuetify.breakpoint.mobile ? 'no-contrats' : 'align-center'"
            >
          </v-col>
          <v-col
            cols="12"
            offset-md="1"
            md="7"
          >
            <div class="d-flex flex-column">
              <div
                class="font-weight-bold secondary--text"
                :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
              >
                Ma synthèse
              </div>
              <div
                class="my-3 texte texte-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? 'w-300' : ''"
              >
                <v-icon
                  class="mr-2 --text-branche"
                >
                  mdi-check
                </v-icon>{{ synthese[0].message }}
              </div>
              <v-divider v-if="synthese.length > 1" />
              <div
                v-if="synthese.length > 1"
                class="my-3 texte texte-gris-fonce"
                :class="$vuetify.breakpoint.mobile ? 'w-300 op-30' : ''"
              >
                <v-icon
                  class="mr-2 --text-branche"
                >
                  mdi-check
                </v-icon>{{ synthese[1].message }}
              </div>
              <v-divider v-if="!$vuetify.breakpoint.mobile && synthese.length > 2" />
              <div
                v-if="!$vuetify.breakpoint.mobile && synthese.length > 2"
                class="my-3 texte texte-gris-fonce op-30"
              >
                <v-icon
                  class="mr-2 --text-branche"
                >
                  mdi-check
                </v-icon>{{ synthese[2].message }}
              </div>
            </div>
          </v-col>
          <!--
            Pas de bouton de redaction en vue mobile : la synthese s'y lit, elle
            ne s'y redige pas. Le crayon qui doublait "Voir ma synthese" a donc
            disparu, et la colonne reprend toute la largeur.
          -->
          <v-col
            v-if="synthese.length > 2"
            cols="12"
            md="2"
            offset-md="1"
            class="align-self-end pr-2"
          >
            <div class="d-flex">
              <AgrButton
                color="primary"
                block
                large
                @click="isOpenModalAdherentSynthese = true"
              >
                <div class="action white--text">
                  Voir ma synthèse
                </div>
              </AgrButton>
            </div>
          </v-col>
        </v-row>
      </div>
      <AgrButton
        v-if="$roles.hasDTEWriteAccess() && !$vuetify.breakpoint.mobile"
        outlined
        :class="$vuetify.breakpoint.mobile ? 'position-btn-saisie-synthese-mobile' : 'position-btn-saisie-synthese'"
        @click="isOpenModalSaisieSynthese = true"
      >
        <div class="d-flex">
          <v-icon
            size="20"
            class="align-self-center mr-2"
          >
            mdi-pencil
          </v-icon>
          <div class="align-self-center action --text-branche">
            Modifier la synthèse
          </div>
        </div>
      </AgrButton>
    </div>
    <v-dialog
      v-model="isOpenModalAdherentSynthese"
      transition="slide-x-transition"
      width="840"
      @click:outside="isOpenModalAdherentSynthese = false"
    >
      <SyntheseAdherentModal
        :loading="loading"
        @close="isOpenModalAdherentSynthese = false"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalSaisieSynthese"
      fullscreen
      transition="slide-x-transition"
      @click:outside="isOpenModalSaisieSynthese = false"
    >
      <SaisieSyntheseModal
        @close="onCloseModal"
      />
    </v-dialog>
  </BaseCardV2>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'
import SyntheseAdherentModal from '../synthese/synthese-adherent-modal.vue'
import SaisieSyntheseModal from '../synthese/saisie-synthese-modal.vue'

export default {
  name: 'Synthese',
  components: { AgrButton, BaseCardV2, BaseLoader, BaseMessage, SyntheseAdherentModal,  SaisieSyntheseModal},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenModalSaisieSynthese: false,
      isOpenModalAdherentSynthese: false,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters({
      synthese: 'syntheseAnalyse/syntheseAnalyse'
    })
  },
  methods: {
    ...mapActions({
    getSyntheseAnalyse: 'syntheseAnalyse/getSyntheseAnalyse'
  }),
    async onCloseModal () {
      this.isOpenModalSaisieSynthese = false
      this.errorMessage = null
      try {
        await this.getSyntheseAnalyse()
      } catch (error) {
          this.errorMessage = 'Une erreur est survenue lors du rafraîchissement de la synthèse.'
      }
    },
  }
}

</script>

<style lang="scss" scoped>
.op-70 {
  opacity: 0.7;
}
.op-30 {
  opacity: 0.3;
}
.align-center {
  margin-left: 25px;
}
.no-contrats {
  width: 20%;
}
.position-btn-saisie-synthese {
  position: absolute;
  right: 35px;
  bottom: 70px;
}
.position-btn-saisie-synthese-mobile {
  position: absolute;
  right: 70px;
  bottom: 70px;
}
/*
 * `max-width` et non `width` : une largeur figee de 300px ne se laisse pas
 * comprimer. Dans la colonne de la carte, qui fait environ 240px sur un
 * telephone, elle depassait d'une soixantaine de pixels - de quoi rendre TOUTE
 * la page scrollable horizontalement, rogner le bord droit des cartes et
 * decaler la barre de navigation du bas.
 */
.w-300 {
  max-width: 300px;
}
</style>
